import { MenuAvailabilityType } from '@restaurant/types';
import { httpClient } from './client';

export type StockCounter = {
  start: number;
  current?: number;
};

export type MenuAvailability = {
  menuAvailabilityId: string;
  restaurantId: string;
  menuId: string;
  menuName: string;
  availabilityType: MenuAvailabilityType;
  stockCounter?: StockCounter;
};

export type CreateMenuAvailabilityRequest = {
  menuId: string;
  availabilityType: MenuAvailabilityType;
  stockCounter?: {
    start: number;
  };
};

const fetchMenuAvailabilities = () => {
  return httpClient().get<{ menuAvailabilities: MenuAvailability[] | null }>(
    '/api/v2/menu-availabilities'
  );
};

const fetchMenuAvailabilityById = (menuAvailabilityId: string) => {
  return httpClient().get<MenuAvailability>(
    `/api/v2/menu-availabilities/${menuAvailabilityId}`
  );
};

const createMenuAvailability = (data: CreateMenuAvailabilityRequest) => {
  return httpClient().post<{ menuAvailabilityId: string }>(
    '/api/v2/menu-availabilities',
    data
  );
};

const deleteMenuAvailability = (menuAvailabilityId: string) => {
  return httpClient().delete(
    `/api/v2/menu-availabilities/${menuAvailabilityId}`
  );
};

export const api = {
  fetchMenuAvailabilities,
  fetchMenuAvailabilityById,
  createMenuAvailability,
  deleteMenuAvailability,
};
